import { render, staticRenderFns } from "./_Checkout.vue?vue&type=template&id=c63d3b10&"
import script from "./_Checkout.vue?vue&type=script&lang=js&"
export * from "./_Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports